module.exports = __webpack_public_path__ + "header-profile-skin-2.png?8307c45ca34d4af71912b535b6c05c54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/header-profile-skin-2.png
// module id = 618
// module chunks = 0